import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';
import { MotionModal } from '../../../components/motion-modal/motion-modal';
import { useDeleteSeriesRecording } from '../../../queries/ats/recordings/mutations';
import { SeriesRecording } from '../../../queries/ats/recordings/types/recording';
import { FocusedAsset } from '../use-focused-asset';
import css from './delete-recording-modal.module.scss';

interface DeleteSeriesRecordingScreenProps {
  focusedAsset: FocusedAsset;
  recording: SeriesRecording;
}

export function DeleteSeriesRecordingScreen() {
  const { t } = useTranslation();

  return (
    <Fragment>
      <MotionModal.ViewButton id="series-keep">{t('recordings:delete-episodes')}</MotionModal.ViewButton>

      <MotionModal.ViewButton id="series-cancel">{t('recordings:delete-series-cancel')}</MotionModal.ViewButton>

      <MotionModal.ViewBackButton className={css.cancel}>{t('cancel')}</MotionModal.ViewBackButton>
    </Fragment>
  );
}

export function DeleteSeriesRecordingKeepScreen({ recording }: DeleteSeriesRecordingScreenProps) {
  const { mutate, isLoading } = useDeleteSeriesRecording();

  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Fragment>
      <p className={css.text}>
        <Trans i18nKey="delete-series-description" ns="recordings" values={{ name: recording.name }} />
      </p>
      <div className={css.actions}>
        <MotionModal.Button
          className={css.confirm}
          onClick={() => mutate({ periodicTaskId: recording.periodicTaskId }, { onSuccess: () => history.goBack() })}
          isLoading={isLoading}
          isDisabled={isLoading}
        >
          {t('confirm')}
        </MotionModal.Button>
        <MotionModal.ViewButton id="series" className={css.cancel} isDisabled={isLoading}>
          {t('cancel')}
        </MotionModal.ViewButton>
      </div>
    </Fragment>
  );
}

export function DeleteSeriesRecordingCancelScreen({ focusedAsset, recording }: DeleteSeriesRecordingScreenProps) {
  const { mutate, isLoading } = useDeleteSeriesRecording();

  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Fragment>
      <p className={css.text}>
        <Trans i18nKey="delete-series-cancel-description" ns="recordings" values={{ name: focusedAsset.titleName }} />
      </p>
      <div className={css.actions}>
        <MotionModal.Button
          className={css.confirm}
          onClick={() =>
            mutate({ periodicTaskId: recording.periodicTaskId, cancel: true }, { onSuccess: () => history.goBack() })
          }
          isLoading={isLoading}
          isDisabled={isLoading}
        >
          {t('confirm')}
        </MotionModal.Button>
        <MotionModal.ViewButton id="series" className={css.cancel} isDisabled={isLoading}>
          {t('cancel')}
        </MotionModal.ViewButton>
      </div>
    </Fragment>
  );
}
